/* eslint no-unused-vars: 0 */
import tokenValidator from 'services/tokenValidator'

// Interval between token revalidations (1 minute)
const TOKEN_REVALIDATION_INTERVAL = 60000

function setValidationInterval() {
  const world = window || global
  if (world.tokenRevalidationTimeout) {
    clearInterval(world.tokenRevalidationTimeout)
  }
  tokenValidator()
  world.tokenRevalidationTimeout = setInterval(
    tokenValidator,
    TOKEN_REVALIDATION_INTERVAL
  )
}

function clearValidationInterval() {
  const world = window || global
  clearInterval(world.tokenRevalidationTimeout)
}

const tokenWatcher = (store) => (next) => (action) => {
  // Keep track of token expiry, auto-logout if no longer valid
  if (action.type === 'persist/REHYDRATE') {
    if (
      action.payload &&
      action.payload.authentication &&
      action.payload.authentication.accessToken
    ) {
      setValidationInterval()
    }
  } else if (action.type === 'LOGIN_SUCCESS') {
    setValidationInterval()
  } else if (action.type && action.type === 'RESET') {
    clearValidationInterval()
  }

  return next(action)
}

export default tokenWatcher
